import VoucherAttachmentService from "../services/voucherattachments.service"

export const FileReadUtils = {
  readFileAsync(file: any) {
    return new Promise((resolve, reject) => {
      // Internet Explorer
      if (!FileReader.prototype.readAsBinaryString) {
        let binary = '';
        // var pt = this;
        const reader = new FileReader();
        reader.onload = () => {
          const bytes = new Uint8Array(reader.result as ArrayBuffer);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          // pt.result  - readonly so assign binary
          // pt.content = binary;
          // pt.onload();
          resolve(binary);
        };
        reader.readAsArrayBuffer(file);
      } else {
        // Other browsers
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsBinaryString(file);
      }
    });
  },

  downloadAttachment(id: any) {
    //@ts-ignore
    var isIE = false || !!document['documentMode'];

    if (!isIE) {
      var win = window.open("");
      //@ts-ignore
      var newDiv = win.document.createElement("div");
      //@ts-ignore
      var newContent = win.document.createTextNode("Dokument wird geladen...");
      newDiv.appendChild(newContent);
      //@ts-ignore
      VoucherAttachmentService.downloadAttachment(id).then((response) => {
        var attachment = response.data;

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE workaround
          var byteCharacters = atob(attachment.data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {type: 'application/pdf'});
          window.navigator.msSaveOrOpenBlob(blob, attachment.fileName);

        } else {

          var byte = this.base64ToArrayBuffer(attachment.data);
          var file = new Blob([byte], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          //@ts-ignore
          win.document.write('<iframe src="' + fileURL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
        }
      });
    }
  },

  base64ToArrayBuffer(_base64Str: any) {
    var binaryString = window.atob(_base64Str);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  },

}
